import React, {useState, useEffect} from 'react';
import {Dialog, DialogProps} from '@priority-software/priority-style-react';
import {setIsNavigationEnabled} from '../../GWTBridge/invoke/genPage';
import {updateTopDialogZindex} from '../../GWTBridge/invoke/priModalDlg';

interface DialogModalProps extends DialogProps {
    onClose: () => void;
    isDialogOpen: boolean;
}

export const DialogModal = (props: DialogModalProps) => {
    const {onClose, isDialogOpen} = props;
    const [isOpen, setIsOpen] = useState(true);
    useEffect(() => {
        setIsOpen(isDialogOpen);
        setIsNavigationEnabled(false);
        updateTopDialogZindex(true);
    }, [isDialogOpen]);

    const onCloseHandler = () => {
        setIsOpen(false);
        setIsNavigationEnabled(true);
        updateTopDialogZindex(false);
        onClose();
    };
    return <Dialog {...props} maskClosable onClose={onCloseHandler} isOpen={isOpen} />;
};
